import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { overviewsSlice } from "@common/redux/slices/entities.slice";
import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { EntityCard } from "@kursk/components/ui/EntityCard/EntityCard";
import { IOverview } from "@common/redux/types/articles";
import { getCardTypeByIdx } from "@kursk/utils/getCardTypeByIdx";
import { useOrientations } from "@common/hooks/useOrientation";
import { useCallback } from "react";

export function ArtefactsGrid() {
  const { items, total, offset } = useSelectSlice(overviewsSlice);
  const orientation = useOrientations()
  const getCardType = useCallback((index) => {
    return getCardTypeByIdx(index, orientation)
  }, [orientation])

  return (
    <EntitiesGrid
      <IOverview>
      entityType="artefacts"
      items={items}
      total={total}
      offset={offset}
      renderGridCard={(item: IOverview, index) => <EntityCard key={item._id} type={getCardType(index)}
        entityType="artefacts" entity={item}/>}
    />
  );
}
